var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 582,
    height: 402,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.142 92.556-38.438-38.438c-3.4117-3.4201-3.4117-8.7588 0-12.171l38.438-38.438c3.4201-3.4201 8.7588-3.4201 12.171 0l38.438 38.438c3.4201 3.4117 3.4201 8.7504 0 12.171l-38.438 38.438c-3.4117 3.4117-8.9673 3.4117-12.171 0z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.001 66.714c0-0.64231 0.20854-1.2763 0.42543-1.9186 0.20854-0.64231 0.64231-1.0677 1.0677-1.4932 0.42542-0.43377 1.0677-0.85919 1.71-1.0677 0.63397-0.21688 1.2763-0.43377 2.1355-0.43377 0.85085 0 1.4932 0.21688 2.1355 0.43377 0.63397 0.20854 1.2763 0.63397 1.7017 1.0677 0.43377 0.42543 0.85919 0.85085 1.0677 1.4932 0.21688 0.64231 0.43377 1.2763 0.43377 1.9186 0 0.64231-0.21688 1.2846-0.43377 1.9269-0.20854 0.63397-0.63397 1.0677-1.0677 1.4932-0.42542 0.42542-1.0677 0.85085-1.7017 1.0677-0.64231 0.20854-1.2846 0.42542-2.1355 0.42542-0.85919 0-1.5015-0.21688-2.1355-0.42542-0.64231-0.21688-1.0677-0.64231-1.71-1.0677-0.42543-0.42543-0.85919-0.85919-1.0677-1.4932-0.21688-0.64231-0.42543-1.0677-0.42543-1.9269zm8.9673-9.8182h-7.691l-1.0677-32.249h9.8265l-1.0677 32.249z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4545e5a27201fb1257794e47e5afcec9.svg";
export { ForwardRef as ReactComponent };